import skid from "../assets/images/accessoires/skid-loader.webp";
import backhoe from "../assets/images/accessoires/backhoe-loader.webp";
import telescopic from "../assets/images/accessoires/telescopic-handler.webp";
const AccessoiresData = [
  {
    id: 1,
    image: skid,
    title: "GF",
    homeTitle: "Accessoires pour mini chargeuses",
    articles: [
      {
        id: 1,
        name: "Balayeuse",
        description1:
          "Balayeuse avec brosses en polypropylène convient pour nettoyer et collecter les matériaux sur les chantiers et racler la boue avec la lame d’attaque.",
        description2:
          "Godet collecteur avec lame d’attaque en acier anti-usure boulonnée réversible (soudée pour le mod. SP 110).",

        image: [require("../assets/images/accessoires-articles/balayeuse.webp")],
        brochure: require("../assets/brochure/gf_balayeuse.pdf")

      },
      {
        id: 2,
        name: "Pelles retro",
        description1:
          "Pelle rétro avec déport latéral à blocage hydraulique, pour excavation à la paroi. Adaptable à mini chargeuse avec contrôles depuis l’intérieur de la cabine.",
        description2:
          "Stabilisateurs hydrauliques indépendants. Godet terrassement standard.",

        image: [require("../assets/images/accessoires-articles/pelle.webp")],
        brochure: require("../assets/brochure/gf_pelle.pdf")

      },
      {
        id: 3,
        name: "Godet Malaxeur",
        description1:
          "Godet malaxeur pour béton avec pales et fond en HARDOX. Chargement du matériel directement par le godet en l’utilisant comme une chargeuse.",
        description2:
          "Déchargement du matériel par la trappe hydraulique qui est au milieu du godet ou par renversement du même godet. Grille de protection antérieure s’ouvrante à charnière pour le nettoyage.",

        image: [require("../assets/images/accessoires-articles/malaxeur.webp")],
        brochure: require("../assets/brochure/gf_malaxeur.pdf")
      },
      {
        id: 4,
        name: "Autre Accessoires",
        description1:
          "Godet malaxeur pour béton avec pales et fond en HARDOX. Chargement du matériel directement par le godet en l’utilisant comme une chargeuse.",
        description2:
          "Déchargement du matériel par la trappe hydraulique qui est au milieu du godet ou par renversement du même godet. Grille de protection antérieure s’ouvrante à charnière pour le nettoyage.",

        image: [require("../assets/images/accessoires-articles/autre.webp")],
        brochure: require("../assets/brochure/gf_all.pdf")
      },
    ],
  },
  {
    id: 2,
    image: backhoe,
    title: "Simex",
    homeTitle: "Accessoires pour tractopelles",
    articles: [
      {
        id: 1,
        name: "Scies a rocher ",
        description1:
          "Expressément conçues pour leur adaptation sur chargeuses compactes, les scies à rocher Simex RW et RWA permettent de traiter différentes surfaces dures, telles que l’enrobé, le béton et la roche et de réaliser des coupes et saignées étroites à section prédéfinie, des mini/micro tranchées pour les réseaux de fibre optique.",
        description2:
          "He lay on his armour-like back, and if he lifted his head a little he could see his brown belly, slightly domed and divided by arches into stiff sections. The bedding was hardly able to cover it and seem",

        image: [require("../assets/images/accessoires-articles/scie.webp")],
        brochure: require("../assets/brochure/scie.pdf")
      },
      {
        id: 2,
        name: "Raboteuse ",
        description1:
          "Les raboteuses auto-nivelantes Simex PL sont conçues pour retirer toute l’épaisseur d’enrobé ou de béton en vue de réaliser une tranchée ou pour la scarification d'une surface délabrée afin de sa remise en état.",
        description2:
          "Elles sont conçues pour raboter des sections prédéfinies sur des surfaces dures et compactes. Les raboteuses auto-nivelantes PL permettent de réutiliser les matériaux scarifiés pour le remblayage ultérieur de la tranchée. Grâce au système auto-nivelant exclusif, la profondeur de travail est constante en toutes conditions.",

        image: [require("../assets/images/accessoires-articles/raboteuse.webp")],
        brochure: require("../assets/brochure/raboteuse.pdf")
      },
      {
        id: 3,
        name: "Autre Accessoires",
        description1:
          "Les raboteuses auto-nivelantes Simex PL sont conçues pour retirer toute l’épaisseur d’enrobé ou de béton en vue de réaliser une tranchée ou pour la scarification d'une surface délabrée afin de sa remise en état.",
        description2:
          "Elles sont conçues pour raboter des sections prédéfinies sur des surfaces dures et compactes. Les raboteuses auto-nivelantes PL permettent de réutiliser les matériaux scarifiés pour le remblayage ultérieur de la tranchée. Grâce au système auto-nivelant exclusif, la profondeur de travail est constante en toutes conditions.",

        image: [require("../assets/images/accessoires-articles/autre-simex.webp")],
        brochure: require("../assets/brochure/raboteuse.pdf")
      },
    ],
  },
  {
    id: 3,
    image: telescopic,
    title: "Bull",
    homeTitle: "Accessoires pour chariots télescopiques",
    description1:
      "",
    description2:
      "",
    articles: [
      {
        id: 1,
        name: "Catalogue géneral",
        image: [
          require("../assets/images/accessoires-articles/bull-all.webp"),
          // require("../assets/images/accessoires-articles/bull6-1.webp"),
          require("../assets/images/accessoires-articles/bull2.webp"),
          require("../assets/images/accessoires-articles/bull3.webp"),
          require("../assets/images/accessoires-articles/bull4.webp"),
          require("../assets/images/accessoires-articles/bull5.webp"),
          require("../assets/images/accessoires-articles/bull6.webp"),],
        brochure: require("../assets/brochure/bull_attach.pdf")
      },
    ],
  },
];

export default AccessoiresData;
